import { ActionType } from 'typesafe-actions';
import BaseReducer, {
baseInitialState,
} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';
import * as tagActions from './tagActions';

export type TagAction = ActionType<typeof tagActions>;

export interface ITagStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: ITagType };
	readonly queries: { [queryKey: string]: ITagType[] };
}

export function tagReducer(
	state = baseInitialState as ITagStateType,
	action: TagAction,
) {
	const Reducer = new BaseReducer('tagReducer', 'slug');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			case 'OTHER_ACTION_TYPE':
				return Object.assign({}, innerState, {
					data: null,
					done: false,
					error: null,
					loading: true,
				});

			default:
				return innerState;
		}
	});
}
